import { render, staticRenderFns } from "./LivestreamAlexaTermsOfService.vue?vue&type=template&id=82e7f84a&scoped=true"
import script from "./LivestreamAlexaTermsOfService.vue?vue&type=script&lang=js"
export * from "./LivestreamAlexaTermsOfService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e7f84a",
  null
  
)

export default component.exports